export const trimIfString = (
  value: string | null | undefined
): string | null => {
  if (!value) return "";

  return typeof value === "string" ? value.trim() : value;
};

// Force trailing slash on string
export const forceTrailingSlash = (str: string): string =>
  str.endsWith("/") ? str : `${str}/`;

export const stripSlashes = (str: string): string =>
  str ? str.replace(/\/$/, "") : str;
